<ds-item-list-preview [item]="dso"
                      [object]="object"
                      [badgeContext]="badgeContext"
                      [showLabel]="showLabel"
                      [showMetrics]="showMetrics"
                      [showThumbnails]="showThumbnails"
                      [showCorrection]="showCorrection"
                      [showWorkflowStatistics]="true"></ds-item-list-preview>

<div class="row">
  <div [ngClass]="showThumbnails ? 'offset-3 offset-xl-2 ps-3' : 'ms-3'">
    <ds-item-actions [object]="dso" (processCompleted)="reloadedObject.emit($event.reloadedObject)"></ds-item-actions>
  </div>
</div>

